<script lang="ts" setup>
import Customer from "@/customer/interfaces/Customer";
import NotificationPreview from "@/core/components/notification-preview/NotificationPreview.vue";
import {NotificationTemplate} from "@/notification-template/interfaces";
import {computed} from "vue";
import NotificationPreviewHeading from "@/core/components/notification-preview/NotificationPreviewHeading.vue";
import RCSNotificationTemplate from "@/notification-template/components/RCSNotificationTemplate.vue";

const props = defineProps<{
    customer: Customer;
    dates: Date[];
    notifications: NotificationTemplate[];
    templateSlug: string
    when: string;
}>();

const template = computed(() => {
    return props.notifications.find((n: NotificationTemplate) => n.slug === props.templateSlug);
});
</script>

<template>
  <div>
    <h3 class="mb-2">
      Le patient recevra :
    </h3>
    <div class="flex flex-col gap-y-6">
      <NotificationPreview
        v-if="template?.type === 'sms'"
        type="sms"
        :count="dates.length"
        :when="when"
        :content="(template.title || '') + '. ' + (template.parsed_content || '')"
      />
      <div v-else-if="template?.type === 'rcs'">
        <NotificationPreviewHeading
          type="sms"
          :when="when"
        />
        <RCSNotificationTemplate class="mt-2" :template="template" />
      </div>
    </div>
  </div>
</template>
